import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Local from '../Local'

Vue.use(VueI18n)
let lang = Local.get('lang') || 'en-US'
Vue.config.locale = lang

export default new VueI18n({
    locale: lang,
    messages: {
        'zh-CN': require('./lang/zh-CN.json'),   // 中文语言包
        'zh-HK': require('./lang/zh-HK.json'),   // 中文语言包
        'en-US': require('./lang/en-US.json')    // 英文语言包
    }
})



// WEBPACK FOOTER //
// ./src/lib/i18n/i18n.js